import launchDarklyFactory from '@mulesoft/anypoint-navbar/raw/services/launchDarkly';
import FeatureFlags from '../types/featureflags'

class FeatureFlagService {
  private static readonly defaults: Record<FeatureFlags, boolean> = {
    [FeatureFlags.ENTITIES_OVERVIEW_LINK_ENABLED]: false,
    [FeatureFlags.TELEMETRY_EXPORTER_CLASSIC_UI_SIDE_NAV_LINK_ENABLED]: false,
    [FeatureFlags.TRACES_OVERVIEW_CLASSIC_UI_SIDE_NAV_LINK_ENABLED]: false,
    [FeatureFlags.API_ANALYTICS_BUILT_IN_DASHBOARD_DISABLED]: false,
    [FeatureFlags.BUILT_IN_DASHBOARDS_SKIP_LOADING_RESOURCES_ENABLED]: false,
    [FeatureFlags.DEFER_LABELS_CALL_IN_LANDING_PAGE_ENABLED]: false,
    [FeatureFlags.MONITORING_CENTER_MPKI_CERTS_EXPIRY_BANNER_ENABLED]: false,
    [FeatureFlags.ALERTS_BASIC_ADVANCED_FILTER_ENABLED]: false,
    [FeatureFlags.ALERTS_TYPE_FILTER_BANNER_ENABLED]: false
  };

  private flags: Record<FeatureFlags, boolean> = { ...FeatureFlagService.defaults };

  async init(organizationId: string, organizationName: string) {
    try {
      const client = await launchDarklyFactory(window.mc.launchDarkly.clientId, organizationId, organizationName);
      this.flags = {
        ...FeatureFlagService.defaults,
        ...client.allFlags(),
      };
      await client.close();
    } catch (e) {
      console.warn('Could not initialize feature flags', e);
    }
  }

  get(flag: FeatureFlags): boolean {
    return this.flags[flag];
  }
}

const singleton = new FeatureFlagService();
export default singleton;
